var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectangleOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 554,
    height: 239,
    viewBox: "0 0 554 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 553,
    height: 238,
    rx: 19.5,
    fill: "url(#paint0_radial_245_1849)",
    stroke: "url(#paint1_linear_245_1849)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_245_1849",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-392.157 -230.376) rotate(17.4986) scale(2509.53 6966.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259615,
    stopColor: "#040209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FD8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_1849",
    x1: -90.2584,
    y1: -129.642,
    x2: -58.6226,
    y2: 265.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DFDA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleOne);
export default __webpack_public_path__ + "static/media/RectangleOne.9fc8e788a7691886d0afe0f0394cef7c.svg";
export { ForwardRef as ReactComponent };